module.exports = __webpack_public_path__ + "static/media/ODS03.b48e0eb3.jpg";